import React from 'react';
import DspxModal from '../../../common/DspxModal/DspxModal';
import { Form, Select } from 'antd';
import styles from './ChangeEntryAllowedStatusModal.module.scss';
import { useMutation } from 'react-query';
import { changeTransportEntry } from '../../../../requests/changeTransportEntry';
import { queryClient } from '../../../../../../queryClient';
import { getQueryKeys } from '../../../../queries/queryKeys';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const { Option } = Select;

const ChangeEntryAllowedStatusNode = ({
  form,
  currentAuto,
  tenantId,
  handleCancel,
  addressId,
  ...props
}) => {
  const { brand, model, number, region, isEntryAllowed } = currentAuto;

  const { resetFields, validateFieldsAndScroll } = form;

  const match = useRouteMatch();

  const changeTransportEntryMutation = useMutation(
    ({ values }) => changeTransportEntry(values),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          getQueryKeys.flatsGrid(Number(match.params.pageId))
        );
        resetFields();
        handleCancel();
      },
    }
  );

  const options = [
    {
      value: 'true',
      label: 'Разрешен',
    },
    {
      value: 'false',
      label: 'Запрещен',
    },
  ];

  const handleSubmit = () => {
    try {
      validateFieldsAndScroll(async (err, fieldValues) => {
        if (!err) {
          const { isEntryAllowed } = fieldValues;

          const values = {
            transportId: currentAuto.id,
            isEntryAllowed: isEntryAllowed === 'true',
            addressId,
          };

          await changeTransportEntryMutation.mutateAsync({ values });
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <DspxModal
      confirmLoading={changeTransportEntryMutation.isLoading}
      destroyOnClose
      onOk={handleSubmit}
      onCancel={handleCancel}
      {...props}
    >
      <h3 className={styles.title}>
        {brand} {model} {number} {region}
      </h3>
      <Form.Item className={styles.container}>
        {form.getFieldDecorator('isEntryAllowed', {
          initialValue: String(isEntryAllowed),
        })(
          <Select
            style={{ width: '100%' }}
            loading={changeTransportEntryMutation.isLoading}
            disabled={changeTransportEntryMutation.isLoading}
          >
            {options.map((option) => (
              <Option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
    </DspxModal>
  );
};

const ChangeEntryAllowedStatusModal = Form.create({
  name: 'change_entry_allowed_status_modal',
})(ChangeEntryAllowedStatusNode);

export default ChangeEntryAllowedStatusModal;
